import type { ReactNode } from "react";

type QuoteRowProps = {
	left?: ReactNode | string | number;
	right?: ReactNode | string | number;
	className?: string;
};

export const QuoteRow = ({ left, right, className }: QuoteRowProps) => {
	return (
		<p className="flex justify-between w-full" data-testid="quote-row">
			<span>{left}</span>
			<span className={className}>{right}</span>
		</p>
	);
};
